import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataStorageService } from '../../_services/data-storage.service';

declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  country: string;
  language: string;
  isClick = true;
  template: string;
  searchText: string;
  query: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dataStorageService: DataStorageService
  ) {
   }

  toggleSearch() {
    this.isClick = !this.isClick;
  }

  search() {
    this.router.navigateByUrl('/' + this.country + '/' + this.language + '/search/' + this.query);
    this.query = '';
  }

  ngOnInit() {
    setTimeout(() => {
      const pathname = window.location.pathname;
      const pathnameSplit = pathname.split('/');
      this.country = pathnameSplit[1];
      this.language = pathnameSplit[2];
      setTimeout(() => {
        $('.app-loading').hide();
        $('body, html').css('overflow', 'unset');
      }, 750);
    }, 1500);
  }

  // onKeydown(event: any) {
  //   if (event.key === 'Enter') {
  //     this.searchText = event.target.value;
  //     this.dataStorageService.searchKey = this.searchText;
  //     console.log(this.dataStorageService.searchKey);
  //     this.router.navigate(['/', this.country, this.language, 'allproducts']);
  //   }
  // }
}
